<template>
  <div class="bb-vat-docs">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <Table :options="optionsTable" :min-height="1500" :totalPages="fullVats.totalPages"/>
    <Pagination :data="fullVats" :getQuery="getVatDocs" :limit="defLimit" class="bb-pagination"/>
  </div>
</template>

<script>
import {vatDocsTable, vatDocsTableColumns} from '@/constants/TablesOptions/vatDocsTable'
import Table from '@/components/Main/Table/Table'
import {find, sortBy, forEach, findIndex, get} from 'lodash'
import vatsApi from '@/api/VATDocs/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import Pagination from '@/components/Main/Pagination/Pagination'
import ContactsApi from '@/api/Contacts/api'

export default {
  name: 'VATDocs',
  props: ['newEntry'],
  components: {
    Table,
    VuePerfectScrollbar,
    LoaderFly,
    Pagination
  },
  data () {
    return {
      optionsTable: vatDocsTable,
      defLimit: 30,
      loaderRun: false,
      fullVats: {}
    }
  },
  computed: {
    vatDocsColumnsData: {
      get: function () {
        return this.$store.getters.vatDocsColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setVatDocsColumnsData', data)
      }
    },
    vatDocsRowsData: {
      get: function () {
        return this.$store.getters.vatDocsRowsData
      },
      set: function (data) {
        this.$store.dispatch('setVatDocsRowsData', data)
      }
    }
  },
  methods: {
    addNewVat () {
      const newVat = {
        newMode: true,
        invoiceNumberString: '',
        invoiceAmount: 0,
        description: '',
        resolve: false,
        taxPeriod: {
          start: new Date(),
          end: new Date()
        },
        create: this.createVatDocs
      }
      if (find(this.vatDocsRowsData, {newMode: true})) return
      this.vatDocsRowsData.unshift(newVat)
    },
    addActions () {
      forEach(this.vatDocsColumnsData, item => {
        if (item.actions) {
          item.actions.delete = this.deleteVatDocs
          item.actions.edit = this.updateVatDocs
        }
      })
    },
    getContactsList () {
      ContactsApi.getContactsList({})
        .then((resp) => {
          this.vatDocsColumnsData.forEach(item => {
            if (item.listName === 'clientsList') {
              item.list = sortBy(resp.data.clients, ['nickName'])
            }
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getVatDocs ({limit = this.defLimit, page = 1}) {
      this.loaderRun = true
      vatsApi.getVatDocs({limit, page})
        .then((resp) => {
          this.loaderRun = false
          this.fullVats = resp.data
          this.vatDocsRowsData = resp.data.vats
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    createVatDocs (item) {
      const client = {...item.originclient}
      delete item.newMode
      delete item.originclient
      vatsApi.createVatDocs(item)
        .then((resp) => {
          if (resp.data.resolve) return
          resp.data.client = client
          this.vatDocsRowsData.unshift(resp.data)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    updateVatDocs (item) {
      const oldClient = item.client
      const newClient = item.originclient
      const clientId = get(item, 'client.id', '')
      clientId ? item.client = clientId : delete item.client
      delete item.uploadFile
      delete item.originclient
      vatsApi.updateVatDocs(item)
        .then((resp) => {
          const index = findIndex(this.vatDocsRowsData, {id: resp.data.id})
          if (index === -1) return
          if (resp.data.resolve) {
            this.vatDocsRowsData.splice(index, 1)
            return
          }
          resp.data.client = newClient || oldClient
          this.vatDocsRowsData.splice(index, 1, resp.data)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deleteVatDocs (id) {
      vatsApi.deleteVatDocs(id)
        .then((resp) => {
          const index = findIndex(this.vatDocsRowsData, {id: id})
          if (index === -1) return
          this.vatDocsRowsData.splice(index, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  watch: {
    newEntry () {
      if (this.newEntry) this.addNewVat()
    }
  },
  beforeMount () {
    this.vatDocsColumnsData = vatDocsTableColumns
    this.getContactsList()
    this.getVatDocs({})
    this.addActions()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-vat-docs {
    @include global-font;
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/InvoiceTable/VATDocs/VATDocs.vue